<script  lang="ts" setup="">
import type { BecomeAuthorData } from '~/utils/crystallize/become-author'
import { getCtaProps } from '~/utils/crystallize/cta'

const { data } = defineProps<{
  data: NonNullable<BecomeAuthorData['components']>['header']
  contactButtonHref?: string
}>()

const cta = computed(() => getCtaProps(data))
</script>

<template>
  <header v-if="data" class="relative overflow-hidden flex flex-col items-center">
    <CrystallizeImage
      v-if="cta.image"
      :image="cta.image"
      class="absolute size-[110%] top-[-5%] left-[-5%] overflow-hidden blur-sm brightness-50"
      img-class="object-cover size-full scale-200"
    />
    <video
      v-else-if="cta.video?.src"
      muted
      autoplay
      loop
      disablePictureInPicture="true"
      :src="cta.video.src"
      class="absolute size-full object-cover overflow-hidden blur-sm brightness-50"
    />

    <div class="relative flex flex-col gap-14 items-center z-[1] py-20 lg:py-52 max-w-4xl mx-m">
      <hgroup class="flex flex-col gap-3 text-center" :class="{ 'text-white': !!cta.image || !!cta.video }">
        <h1 v-if="data.title" v-text="data.title" />

        <CrystallizeRichText v-for="(block, i) in data.text" :key="i" :block="block" />
      </hgroup>

      <Button v-if="contactButtonHref" size="medium" color="moss" variant="primary" :href="contactButtonHref">
        Ta kontakt
      </Button>
    </div>
  </header>
</template>
